"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ConsentManagerProvider } from "@c15t/react";
import { useState } from "react";

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
      },
    },
  }));

  return (
    <QueryClientProvider client={queryClient}>
      <ConsentManagerProvider
        options={{
          mode: "hosted",
          backendURL: "/api/c15t",
        }}
      >
        <TooltipProvider>{children}</TooltipProvider>
      </ConsentManagerProvider>
    </QueryClientProvider>
  );
}
